export * from './blog';
export * from './catalog';
export * from './comment';
export * from './cookie';
export * from './header';
export * from './product';
export * from './downloadFile';
export * from './user-helpers';
export * from './promotions';
export * from './videos';
export * from './downloadFile';
export * from './ecommerce';
export * from './geo';
export * from './gift';
export * from './sale';

export const makeid = (length) => {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
};

export const decodeHtmlEntities = (str) => {
  const textarea = document.createElement('textarea');
  textarea.innerHTML = str;
  return textarea.value;
};
